<template>
    <div v-if="casestudy" class="case-study overflow-hidden">
        <div class="case-study__intro relative w-full h-screen bg-center bg-cover overflow-hidden"
             :style="{backgroundImage : 'url('+casestudy.caseStudyIntroImage[0].url+')'}">
            <div class="case-study__numbers-container overflow-hidden">
                <svg xmlns="http://www.w3.org/2000/svg" :viewBox="'0 0 '+casestudy.caseStudyNumbersWidth+' 900'"
                     class="case-study__numbers h-screen mx-auto opacity-20" v-html="casestudy.caseStudyNumbers"></svg>
            </div>
            <div class="case-study__client-container">
                <div class="case-study__client-content overflow-hidden">
                    <h1 ref="client" class="case-study__client font-coign-bold text-black text-max md:text-20xl leading-none tracking-minwide uppercase whitespace-no-wrap text-center">
                        <span ref="heroTitle" class="case-study__client-text">{{ casestudy.caseStudyClient }}</span>
                    </h1>
                </div>
            </div>
        </div>

        <div class="case-study__presentation mt-22 max-w-2xxl mx-auto px-10">
            <p v-if="casestudy && casestudy.caseStudyDescription"
               class="font-codesaver-regular text-black text-base md:text-2xl leading-normal max-w-lg"
               v-html="casestudy.caseStudyDescription.content"></p>
            <a v-if="casestudy && casestudy.caseStudyWebsite" :href="casestudy.caseStudyWebsite" target="_blank"
               class="mt-10 block font-codesaver-regular font-medium text-black text-base md:text-2xl leading-normal">Visit
                live website</a>
            <div class="mt-16 flex flex-row justify-between items-start">
                <p v-if="casestudy && casestudy.caseStudyRole"
                   class="font-codesaver-regular text-black text-sm md:text-sm leading-normal">
                    ROLE : <br/><br/>
                    <span v-html="casestudy.caseStudyRole.content"></span>
                </p>
                <p v-if="casestudy && casestudy.caseStudyCommission" class="font-codesaver-regular text-black text-sm md:text-sm leading-normal italic">
                    Commisionned by
                    <a v-if="casestudy.caseStudyCommissionLink" :href="casestudy.caseStudyCommissionLink" class="case-study__underline text-black whitespace-no-wrap no-underline">{{ casestudy.caseStudyCommission }}</a>
                    <span v-else>{{ casestudy.caseStudyCommission }}</span>
                </p>
            </div>
        </div>

        <div class="case-study__projects-container">
            <template v-if="projects">
                <case-study-project v-for="project in projects.caseStudyLinkProjects" :project="project"></case-study-project>
            </template>
        </div>

        <div class="case-study__nav h-68 md:h-68 bg-black mt-52 flex justify-center items-center">
            <router-link :to="{path : '/casestudy/' + nextSlug}" class="case-study__next-link relative font-signal-regular text-2xl md:text-3xl text-white uppercase tracking-extrawide no-underline">
                Next
            </router-link>
        </div>

        <case-study-sticky-header></case-study-sticky-header>
    </div>
</template>

<script>
    import _ from 'lodash';
    import {mapState, mapMutations} from 'vuex';
    import gql from 'graphql-tag';
    import CaseStudyProject from '../components/CaseStudyProject';
    import CaseStudyStickyHeader from '../components/CaseStudyStickyHeader';

    export default {
        name: 'case-study',

        components: { CaseStudyProject, CaseStudyStickyHeader },

        data(){
            return {
                nextSlug : null,

                titleWidth : null
            }
        },

        computed: {
            ...mapState([
                'casestudies',
                'currentCasestudy'
            ])
        },

        apollo: {
            casestudies : {
                query : gql`query {
                    casestudies : entries(type:CaseStudy){
                    ... on CaseStudy {
                            id
                            title
                            slug
                        }
                    }
                }`,

                result({data}){
                    this.$store.commit('updateCaseStudies', data.casestudies);

                }
            },

            casestudy: {
                query: gql`query($slug : String!) {
                    casestudy : entry(slug:$slug){
                    ... on CaseStudy {
                            id
                            title
                            slug
                            caseStudyIntroImage{
                                url
                                width
                                height
                            }
                            caseStudyNumbers
                            caseStudyNumbersWidth
                            caseStudyClient
                            caseStudyDescription {
                                content
                            }
                            caseStudyWebsite
                            caseStudyCommission
                            caseStudyCommissionLink
                            caseStudyRole {
                                content
                            }
                            caseStudyLinkProjects {
                               id
                            }
                        }
                    }
                }`,

                variables() {
                    return {slug: this.$route.params.slug}
                },

                result({data}) {
                    var casestudy = _.find(this.casestudies, (pObj) => {
                        return pObj.id === this.casestudy.id
                    });
                    var index = _.indexOf(this.casestudies, casestudy);

                    this.$store.commit('updateCurrentCasestudy', index);

                    if(index + 1 > this.casestudies.length -1){ index = 0 }

                    // Save next slug
                    this.nextSlug = this.casestudies[index + 1].slug;
                }
            },

            projects: {
                query: gql`query ($slug: String) {
                  projects: entry(slug: $slug) {
                    ... on CaseStudy {
                        id
                      caseStudyLinkProjects {
                        ... on Project {
                          caseStudyProject
                          caseStudyBody {
                            ... on CaseStudyBodyStandardImage {
                              caseStudyImagesStandardImage {
                                desktopImage {
                                  url
                                  height
                                }
                                mobileImage {
                                  url
                                }
                              }
                            }
                            ... on CaseStudyBodyThreeImages {
                              caseStudyImagesThreeImages {
                                imageOne {
                                  url
                                }
                                imageTwo {
                                  url
                                }
                                imageThree {
                                  url
                                }
                              }
                            }
                            ... on CaseStudyBodyTwoImagesBigSaml {
                              caseStudyImagesTwoImagesBigSmall {
                                mobileImageOne {
                                  url
                                }
                                mobileImageTwo {
                                  url
                                }
                                desktopImageTwo {
                                  url
                                }
                                addSpace
                                leftRight
                              }
                            }
                            ... on CaseStudyBodyTwoEqualsImages {
                              caseStudyImagesTwoEqualsImages {
                                mobileImageOne {
                                  url
                                }
                                desktopImageOne {
                                  url
                                }
                                mobileImageTwo {
                                  url
                                }
                                desktopImageTwo {
                                  url
                                }
                                addSpace
                              }
                            }
                            ... on CaseStudyBodyImageFull {
                              caseStudyImagesFullWidth {
                                mobileImage {
                                  url
                                }
                                desktopImage {
                                  url
                                }
                              }
                            }
                            ... on CaseStudyBodyVideo {
                              video {
                                url
                              }
                            }
                            ... on CaseStudyBodyFourImages {
                              caseStudyImagesFourImages {
                                mobileImageOne {
                                  url
                                }
                                mobileImageTwo {
                                  url
                                }
                                desktopImageTwo {
                                  url
                                }
                                mobileImageThree {
                                  url
                                }
                                desktopImageThree {
                                  url
                                }
                                mobileImageFour {
                                  url
                                }
                                desktopImageFour {
                                  url
                                }
                                addSpace
                                leftRight
                              }
                            }
                          ... on CaseStudyBodyCarousel {
                              caseStudyCarousel {
                                url
                                width
                                height

                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }`,

                variables() {
                    return {slug: this.$route.params.slug}
                }
            }
        },


        metaInfo(){
            return {
                titleTemplate: 'Designus'
            }
        },

        mounted() {
            this.$store.commit('updateHeaderColor', 'black');
        },

        methods: {
            ...mapMutations([
                'updateHeaderColor'
            ])
        }
    }
</script>

<style lang="scss">
    @import "../assets/styles/_globals.scss";

    .case-study {
        &__underline {
            position : relative;

            &::after {
                content : '';
                width: calc(100%);
                height: 1px;
                position: absolute;
                bottom: -2px;
                left: 1px;
                background-color : black;
            }
        }

        &__client{
             @include responsive-font(30vw, 30vw, 31.25rem, 31.25rem);
         }

        &__numbers-container, &__client-container {
            @include top-left(50%, 50%);
            transform: translate(-50%, -50%);
        }

        &__numbers path{
            fill : black;
        }

        &__next-link {
            &::after {
                content: "";
                @include size(calc(100% - 18px), 2px);
                position: absolute;
                bottom: -4px;
                left: 5px;
                transition: all 0.4s;

            }

            &.text-white:after {
                background-color: white;
            }

            &.text-black:after {
                background-color: black;
            }

            &:hover {
                &:after {
                    animation-name: linkhover;
                    animation-duration: 0.5s;
                }
            }
        }

        @keyframes linkhover {
            0% {
                width: calc(100% - 18px);
                right: 18px;
                left: auto;
            }

            50% {
                width: 0;
                right: 3px;
                left: auto;
            }

            51% {
                width: 0;
                left: 5px;
                right: auto;
            }

            99% {
                width: calc(100% - 18px);
                left: 5px;
                right: auto;
            }

            100% {
                width: calc(100% - 18px);
                right: 18px;
                left: auto;
            }
        }
    }
</style>